import styled from 'styled-components';

export const WrapperMain = styled.main`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
background-image: linear-gradient(
  to bottom,
  #00b9ff 0%,
  #ffb800
);
background-size: cover;

`;
